/* Veiln Massimo Dutti behaviour — size chart drawer, swatches, view switcher */
(function () {
  'use strict';

  // ---- 1. Size chart drawer --------------------------------------------------
  function buildSizeChart(data) {
    if (!data) return '';
    const body = data.body || {};
    const item = data.item || {};
    const sizes = (body.sizes || []).map(s => `<div class="veiln-size-chart__grid-cell" data-eu="${s.eu}"><span class="eu">${s.eu}</span><span class="us">${s.us}</span></div>`).join('');

    const renderTable = (tab) => {
      const rows = (tab.measurements_cm || []).map(m => {
        const cols = m.values.map(v => `<td>${v} cm</td>`).join('');
        return `<tr><td>${m.name}</td>${cols}</tr>`;
      }).join('');
      const headers = (tab.sizes || []).map(s => {
        if (typeof s === 'string') return `<th>${s}</th>`;
        return `<th>${s.eu} / ${s.us}</th>`;
      }).join('');
      return `<table class="veiln-size-chart__table"><thead><tr><th></th>${headers}</tr></thead><tbody>${rows}</tbody></table>`;
    };

    return `
      <button class="veiln-size-chart__close" aria-label="Close">&times;</button>
      <div class="veiln-size-chart__tabs">
        <button class="veiln-size-chart__tab is-active" data-tab="body">ITEM MEASUREMENTS</button>
        <button class="veiln-size-chart__tab" data-tab="item">BODY MEASUREMENTS</button>
      </div>
      <div class="veiln-size-chart__label">SELECT SIZE</div>
      <div class="veiln-size-chart__grid">${sizes}</div>
      <div class="veiln-size-chart__pane" data-pane="body">${renderTable(body)}</div>
      <div class="veiln-size-chart__pane" data-pane="item" hidden>${renderTable(item)}</div>
      <button class="veiln-size-chart__unit-toggle" data-unit="cm">See in inches</button>
    `;
  }

  function openSizeChart(data) {
    let root = document.getElementById('veiln-size-chart-root');
    if (!root) return;
    let drawer = document.querySelector('.veiln-size-chart');
    let overlay = document.querySelector('.veiln-size-chart__overlay');
    if (!drawer) {
      overlay = document.createElement('div');
      overlay.className = 'veiln-size-chart__overlay';
      drawer = document.createElement('aside');
      drawer.className = 'veiln-size-chart';
      drawer.innerHTML = buildSizeChart(data);
      root.appendChild(overlay);
      root.appendChild(drawer);
      const close = () => { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); };
      drawer.querySelector('.veiln-size-chart__close').addEventListener('click', close);
      overlay.addEventListener('click', close);
      drawer.querySelectorAll('.veiln-size-chart__tab').forEach(t => {
        t.addEventListener('click', () => {
          drawer.querySelectorAll('.veiln-size-chart__tab').forEach(x => x.classList.remove('is-active'));
          t.classList.add('is-active');
          drawer.querySelectorAll('.veiln-size-chart__pane').forEach(p => { p.hidden = (p.dataset.pane !== t.dataset.tab); });
        });
      });
      drawer.querySelectorAll('.veiln-size-chart__grid-cell').forEach(c => {
        c.addEventListener('click', () => {
          drawer.querySelectorAll('.veiln-size-chart__grid-cell').forEach(x => x.classList.remove('is-active'));
          c.classList.add('is-active');
        });
      });
      const unitBtn = drawer.querySelector('.veiln-size-chart__unit-toggle');
      unitBtn.addEventListener('click', () => {
        const inCm = unitBtn.dataset.unit === 'cm';
        drawer.querySelectorAll('.veiln-size-chart__table td').forEach(td => {
          const m = td.textContent.match(/^([\d.]+)\s*(cm|in)$/);
          if (!m) return;
          let v = parseFloat(m[1]);
          if (inCm) {
            td.textContent = (v / 2.54).toFixed(1) + ' in';
          } else {
            td.textContent = Math.round(v * 2.54) + ' cm';
          }
        });
        unitBtn.dataset.unit = inCm ? 'in' : 'cm';
        unitBtn.textContent = inCm ? 'See in centimetres' : 'See in inches';
      });
    }
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
    });
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-veiln-size-chart]');
    if (!trigger) return;
    e.preventDefault();
    let data;
    try { data = JSON.parse(trigger.getAttribute('data-veiln-size-chart')); } catch (_) {}
    openSizeChart(data);
  });

  // ---- 2. Color swatches on PDP ----------------------------------------------
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.veiln-swatch');
    if (!sw) return;
    e.preventDefault();
    const group = sw.closest('.veiln-swatches');
    group.querySelectorAll('.veiln-swatch').forEach(x => x.setAttribute('aria-pressed', 'false'));
    sw.setAttribute('aria-pressed', 'true');
    const label = sw.closest('.veiln-color-block').querySelector('.veiln-swatch-label strong');
    if (label) label.textContent = sw.dataset.colorName;
    // also flip the Shopify variant radio under the hood
    const colorVal = sw.dataset.colorName;
    document.querySelectorAll('input[type="radio"][name*="Color"]').forEach(r => {
      if (r.value === colorVal) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // ---- 3. Collection view switcher -------------------------------------------
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-veiln-view-set]');
    if (!btn) return;
    e.preventDefault();
    const v = btn.dataset.veilnViewSet;
    const target = document.querySelector('[data-veiln-view-target]') || document.querySelector('main') || document.body;
    target.setAttribute('data-veiln-view', v);
    document.querySelectorAll('[data-veiln-view-set]').forEach(b => b.classList.toggle('is-active', b === btn));
    try { localStorage.setItem('veiln-view', v); } catch (_) {}
  });

  // Restore preference
  document.addEventListener('DOMContentLoaded', () => {
    let v;
    try { v = localStorage.getItem('veiln-view'); } catch (_) {}
    if (!v) v = '2';
    const target = document.querySelector('[data-veiln-view-target]') || document.querySelector('main');
    if (target) target.setAttribute('data-veiln-view', v);
    const btn = document.querySelector(`[data-veiln-view-set="${v}"]`);
    if (btn) btn.classList.add('is-active');
  });

  // ---- 4. ADD TO BASKET label override (Massimo style) -----------------------
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-form__submit span').forEach(s => {
      if (/add to cart/i.test(s.textContent.trim())) s.textContent = 'ADD TO BASKET';
    });
  });
})();
